























































































































































































































































































































import {Component, Ref, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import {cloneDeep, isEqual} from "lodash";
import {SelectWings, NumberWings, TimeoutWings} from "wings-ui-components";
import {QuantityLimitItemImpl} from '@/store/settings/quantity_limits/types';
import {notifyConfirm, notifyDelete, notifyError} from '@/utils/notify-helper';
import {TransportItem} from '@/store/transport/types';
import {MessageTypeItem} from "@/store/settings/message_types/types";
import {TemplateItem} from "@/store/sms/templates/types";
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";

Component.registerHooks(['beforeRouteLeave']);

@Component({
  components: {NumberWings, TimeoutWings, SelectWings},
})
export default class QuantityLimit extends Vue {
  @Ref('validator') validator: any;

  @Action('getTransports') actionGetTransports: any;
  @Action('getQuantityLimitItem') actionGetItem: any;
  @Action('saveQuantityLimit') actionSave: any;
  @Action('deleteQuantityLimit') actionDelete: any;
  @Action("getMessageTypes") actionGetMessageTypes: any;
  @Action('getTemplates') actionGetTemplates: any;
  @Action("actionLog") actionLog: any;

  @Getter("messageTypes") messageTypesList?: MessageTypeItem[];
  @Getter('transports') transportsList!: TransportItem[];
  // @Getter('allTemplates') templatesList!: TemplateItem[];

  private item = new QuantityLimitItemImpl();
  private itemSaved = new QuantityLimitItemImpl();
  private logObject: ActionLog = {};

  allowedTransports = ['sms', 'call', 'email', 'push', 'viber', 'whatsapp']

  smsTemplate = null
  callTemplate = null
  emailTemplate = null
  pushTemplate = null
  viberTemplate = null
  whatsappTemplate = null
  templates: any = {
    sms: [],
    call: [],
    email: [],
    push: [],
    viber: [],
    whatsapp: [],
  }
  templatesList: any = []

  async getTemplatesList(filter: any, transport: string) {
    const items = await this.actionGetTemplates({transport, filter});
    this.templatesList = (filter?.page_number > 1) ? this.templatesList.concat(items) : items
  }

  onAddTemplate(val: number, transport: string) {
    if (!val || this.templates[transport].find((item: any) => item.id == val)) {
      return
    }
    const option = this.templatesList.find((item: any) => item.id == val)
    console.log(transport, val, option)
    this.templates[transport].push(option)
  }

  onDeleteChip(sel: any, transport: string) {
    console.log('onDeleteChip', transport, sel)
    const idx = this.templates[transport].findIndex((item: any) => item.id == sel.id)
    this.templates[transport].splice(idx, 1)
  }

  async created() {
    try {
      await this.actionGetTransports();
      await this.actionGetMessageTypes();

      if (this.$route.params.id) {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "The rule for limiting the quantity of messages",
          addititional_info: getTranslatedParams(this.item)
        }
        const data = await this.actionGetItem(this.$route.params.id);
        await this.actionLog(this.logObject);
        this.item = Object.assign({}, this.item, data);
        this.itemSaved = cloneDeep(Object.assign({}, this.item, data));

        if (this.item.template_ids?.length) {
          this.item.transport_ids?.forEach(async (id: number) => {
            let transport = this.getTransportNameById(id)?.toLowerCase()
            if (transport)
              this.templates[transport] = await this.actionGetTemplates({transport, filter: {ids: this.item.template_ids?.join(',')}});
          })
        }
      }
    } catch (error) {
      this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(error);
    }
  }

  get transportsQuantityLimitList(): TransportItem[] {
    return this.transportsList.filter((t: TransportItem) => this.allowedTransports.includes(t.name.toLowerCase()));
  }

  back(): void {
    this.$router.push('/settings/quantity_limits/');
  }

  onSaveItem() {
    return new Promise<void>(async (resolve, reject) => {
      if (!await this.validator.validate()) {
        notifyError(null, this.validator.errors)
        return
      }
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: this.$route.params.id ? "Editing" : "Creation",
          action_status: "success",
          object_type: "The rule for limiting the quantity of messages",
          addititional_info: getTranslatedParams(this.item)
        }
        let template_ids: any = []
        for (let transport in this.templates) {
          this.templates[transport].forEach((item: any) => template_ids.push(item.id))
        }
        this.item.template_ids = template_ids

        await this.actionSave(this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        resolve()
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        reject();
        notifyError(error);
      }
    })
  }

  async onDeleteItem() {
    if (!await notifyDelete()) return
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Removal",
        action_status: "success",
        object_type: "The rule for limiting the quantity of messages",
        addititional_info: getTranslatedParams({id: this.item.id})
      }
      await this.actionDelete(this.item);
      await this.actionLog(this.logObject);
      this.itemSaved = this.item;
      this.back();
    } catch (error) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(error);
    }
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    let isChange = !isEqual(this.item, this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

  checkAllowTransport(value: string): any {
    return this.item.transport_ids?.includes(this.getTransportIdByName(value));
  }

  getTransportIdByName(name: string): any {
    if (this.transportsList) {
      return this.transportsList.find((t: any) => t.name.toLowerCase() == name.toLowerCase())?.id;
    }
  }

  getTransportNameById(id: number) {
    if (this.transportsList) {
      return this.transportsList.find((t: any) => t.id == id)?.name
    }
  }

  // При выборе транспорта удаляется те шаблоны которые ему принадлежат
  @Watch('item.transport_ids', {immediate: false, deep: true})
  onChangeTransportIds() {
    this.transportsQuantityLimitList?.forEach((transport: any) => {
      if (!this.item.transport_ids?.find((id: number) => transport.id == id)) {
        this.templates[transport.name.toLowerCase()] = []
      }
    })
  }

}
